import { getAdminPinImages } from '../../utils/images';
import AdminClusteredPins from './AdminClusteredPins';

export default AdminClusteredPins;

export const adminClusteredPinsImages = getAdminPinImages(['pinImage', 'clusterImage', 'pinImageSelected']);
